import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { Facturarticket } from './modelo/facturarticket';
import { MConexiones, BASE_URL } from '../conexiones';
import { ConsultarFactura } from './modelo/consultarFactura';

@Injectable({
  providedIn: 'root'
})
export class FacturacionService {
  public conn: MConexiones;
  private baseUrl: string = "";

  constructor(private _http: HttpClient) {
    this.conn = new MConexiones();
    this.conn.obtenerConexion();
    this.baseUrl = BASE_URL;
  }


  /** ************************************* FIN ************************************* */
  private token: string = "eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsImp0aSI6IjFiYjA4ZGNiMjgxYmJjMTJkNmNmZDY1ZDY1NmVmYzBiMzk3NWZlMjU3YmJjM2RmNjA4NDJmOWVjOTI2ODU2NDIzYWE4ZWI2YmUxZmFlMTg5In0.eyJhdWQiOiIxIiwianRpIjoiMWJiMDhkY2IyODFiYmMxMmQ2Y2ZkNjVkNjU2ZWZjMGIzOTc1ZmUyNTdiYmMzZGY2MDg0MmY5ZWM5MjY4NTY0MjNhYThlYjZiZTFmYWUxODkiLCJpYXQiOjE2NTIxMzQ5MjgsIm5iZiI6MTY1MjEzNDkyOCwiZXhwIjo0ODA3ODEyMTI4LCJzdWIiOiI0Iiwic2NvcGVzIjpbXX0.IU8AZGnNOkbhuYDbayWE50iltTAoZqswalQKQhk9NbroSbJW3ek72swcfLemPC19gUJlct5P7r8esUIKr6qd5NsDed3Cw6OWaLiFEzAw1lqhX_hv0ewYA3u0nVrJ62mpcL8wSUXHiaozkdsltuzFhFctgE3PJJI4-wTOXGNBGE2tGV_I6-WtcvLsTV6BBh6SYFVg0aBEGmg3LrTMluK2zxAn-ZKR4ZJPvweTN-DuTbngp9jnAFcJjJnb2w8OlfwwwCjHolX6DN0XBI7MtEOO_mB-GbIJ6E7hAbF3QerURCVVjL9KuTV7BHJG2uKNCfkzMSCBgdnknHXGeTJdvsgnDs_cm6kXxigYEFujf3oVvKcFVAQcsyt-Xsgri1SjTOpa5-OG2yG8zM0Upe5W7ZStwdU10KjpKBFANR6uWDwI9Z3oZ3OlA4OKcuyqubzU3k_FbelTZR0VnFDg23fyiWyieU6o0ezpp5tMEtzahbGnje8vp4wALv988Qb1V829738r8f1WeLnQOYMWR57NUc6YRPwV2WZFACS1GlvBLOkzGCGxna2MEwfRYX25oVCRSyr2KIwcQrukKz6oz45NmWP1BvYyjx9XeRaLc4o9lsikwn40COWpeti38Oa6YD48MeUiKxOvbc1iNgLFRKB61XxM_mkTeH-a39rPZYStXJ4OJmg";
  //private token:string = "eyeerjeworekjljkjpouiuouieurwrwjrjoijorjw";
  private headers = new HttpHeaders().set("Authorization", 'Bearer ' + this.token);

  /*
  creatUser(){
    this.headers.append('Content-Type','application/x-www-form-urlencoded');
    this.headers.append('X-Requested-With','XMLHttpRequest');
    let options = new RequestOptions({ headers: this.headers });

    let path = 'signup';
    let body = new URLSearchParams();
    body.set('name', 'test18');
    body.set('email', 'copico_test18@gmail.com');
    body.set('password', '123');
    body.set('password_confirmation', '123');
    return this._http.post(this.baseUrl+path,body.toString(),options)
    .pipe( map(res => res.json()) )
  }*/
  /*
   getUser(){
     let options = new RequestOptions({ headers:this.headers });
     let path = "login";
     let body = new URLSearchParams();
     body.set('email','copico_test18@gmail.com');
     body.set('password','123');
     body.set('remember_me','true');
     return this._http.post(this.baseUrl+path,body.toString(),options)
     .pipe( map(res => res.json()) )

   }*/

  validateFolioTicketVenta(dataTicket: Facturarticket) {
    let path = "validarTicketVenta";
    return this._http.post(this.baseUrl + path, dataTicket, { headers: this.headers })
      .pipe(map(res => res))
  }

  facturarTicketVenta(dataTicket: Facturarticket) {
    let path = "guardarTicketVenta";
    return this._http.post(this.baseUrl + path, dataTicket, { headers: this.headers })
      .pipe(map(res => res))
  }

  obtenerFormatoTicket(claveComprobanteFiscal: number,codigoVenta,codigoComprobante) {

    let path = "formatoImpresionTicket";
    //console.log("la url: " + this.baseUrl + path);
    //console.log("claveComprobanteFiscal: " + claveComprobanteFiscal);
    return this._http.post(this.baseUrl + path, { claveComprobanteFiscal,codigoVenta,codigoComprobante }, { headers: this.headers });


  }

  mandarImprimirLocal(formatoTicket: any) {

    let path = "imprimir";

    return this._http.post("http://localhost:5000/" + path, formatoTicket, { headers: this.headers });
  }


  guardarImpactoDirecto(claveComprobante: number, razonSocial: string, rfcReceptor: string, timbrado: boolean, rfcActivoDb: boolean) {
    let path = "guardarImpactoDirecto";

    let data = { claveComprobante: claveComprobante, razonSocial: razonSocial, rfcReceptor: rfcReceptor, timbrado: timbrado, rfcActivoDb: rfcActivoDb };
    return this._http.post(this.baseUrl + path, data, { headers: this.headers })
      .pipe(map(res => res))
  }

  descargarTicketDeVenta(ticket: string, folio: string, servidor: string, isDescarga = 1, correo: string) {
    return this._http.post(this.baseUrl + "descargarTicket", { ticket, folio, isDescarga, servidor, correo }, { responseType: 'blob' })
      .pipe(map(res => {
        return new Blob([res], { type: " application/pdf" })
      }))
  }

  descargarPDF(path) {
    return this._http.get(path, { responseType: 'blob' })
      .pipe(map(res => {
        return new Blob([res], { type: "application/octet-stream" })
      }))
  }

  // enviarEmail(path:string)
  // {
  //   return this._http.get(path).pipe( map(res => res) );
  // }
  enviarEmail(path: string, datos: any) {
    return this._http.post(path, datos).pipe(map(res => res));
  }

  obtenerEstados(clavePais) {
    return this._http.get(this.baseUrl + 'obtenerEstados/' + clavePais, { headers: this.headers }).pipe(map(res => res));
  }

  obtenerMunicipios(claveEstado) {
    return this._http.get(this.baseUrl + 'obtenerMunicipios/' + claveEstado, { headers: this.headers }).pipe(map(res => res));
  }

  obtenerConsultarFactura(url: string, consultarfactura: ConsultarFactura) {
    return this._http.post(url, consultarfactura).pipe(map(res => res));
  }

  obtenerPromociones(servidor: string) {
    return this._http.post(this.baseUrl + 'obtenerPromociones', { servidor: servidor }, { headers: this.headers }).pipe(map(res => res));
  }

  obtenerUsoCFDI(claveRegimenFiscal: string, servidor: string) {
    return this._http.get(this.baseUrl + 'obtenerUsoCFDI/' + claveRegimenFiscal + '/' + servidor, { headers: this.headers }).pipe(map(res => res));
  }


  obtenerFacturas(servidor: string, paginaActual: number, fechaInicio: string, fechaFin: string, folio: String, codigoComprobanteVenta: String) {
    return this._http.post(this.baseUrl + 'buscarFacturas', { servidor: servidor, paginaActual, fechaInicio, fechaFin, folio, codigoComprobanteVenta }, { headers: this.headers }).pipe(map(res => res));
  }
}
